<template>
  <ExamDo @submit="onSubmit" :isFile="20">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <span class="current">随机练习</span>
      </div>
    </template>
  </ExamDo>
</template>
<script>
import ExamDo from './components/ExamDo.vue';
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamRandomDo',
  components: {
    ExamDo,
    ExamIndexBread,
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: 'ExamRandomReport',
        query: {
          id: this.$route.query.id,
        },
      });
    },
  },
};
</script>
